(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-range-header"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialise = () => {
      document.querySelectorAll('[data-brand-header]').forEach(header => {
        if (header.dataset.brandReady) return;
        header.dataset.brandReady = 'true';
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const updates = [];
        header.querySelectorAll('[data-brand-carousel]').forEach(carousel => {
          const track = carousel.querySelector('[data-brand-track]');
          const previous = carousel.querySelector('[data-brand-prev]');
          const next = carousel.querySelector('[data-brand-next]');
          const update = () => {
            if (previous) previous.disabled = track.scrollLeft <= 2;
            if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
          };
          const move = direction => {
            const item = Array.from(track.children).find(child => !child.hidden);
            if (!item) return;
            const step = item.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
            track.scrollBy({left:direction * step,behavior:reducedMotion.matches ? 'auto' : 'smooth'});
          };
          previous?.addEventListener('click', () => move(-1));
          next?.addEventListener('click', () => move(1));
          track.addEventListener('scroll', update, {passive:true});
          new ResizeObserver(update).observe(track);
          updates.push(update);
          update();
        });
        const links = Array.from(header.querySelectorAll('[data-brand-range-link]'));
        const syncRanges = () => {
          links.forEach(link => {
            const shelf = document.getElementById(link.hash.slice(1));
            const slider = shelf?.querySelector('.productShelfSlider');
            link.hidden = !slider || slider.style.display === 'none';
          });
          const nav = header.querySelector('.epic-collection-brand-ranges');
          if (nav) nav.hidden = !links.some(link => !link.hidden);
          updates.forEach(update => update());
        };
        const observer = new MutationObserver(syncRanges);
        links.forEach(link => {
          const slider = document.getElementById(link.hash.slice(1))?.querySelector('.productShelfSlider');
          if (slider) observer.observe(slider, {attributes:true,attributeFilter:['style']});
          link.addEventListener('click', () => {
            document.dispatchEvent(new CustomEvent('allure:range:jump', {detail:{id:link.hash.slice(1)}}));
          });
        });
        syncRanges();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, {once:true});
    else initialise();
    document.addEventListener('shopify:section:load', initialise);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["epic-buy-now"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const button = document.querySelector('[data-epic-buy-now]');
    if (!button || button.dataset.initialised) return;
    button.dataset.initialised = 'true';
    const row = button.closest('.epic-product-actions');
    const product = button.closest('.epic-product-buy');
    const add = product.querySelector('#productTemplate-addToBagButton');
    const message = product.querySelector('#epic-buy-now-status');
    if (!row || !add || !message) return;
    let running = false;
    let timer;
    let locked = [];
    const available = () => {
      const variant = [...product.querySelectorAll('[data-variant-available]')]
        .find(option => option.dataset.variantId === add.dataset.variantId);
      return (variant?.dataset.variantAvailable || button.dataset.available) === 'true';
    };
    const sync = () => {
      button.disabled = running || !available() || !window.AE?.cart?.prepareCheckout || window.AE.cart.busy;
    };
    const reset = () => {
      clearTimeout(timer);
      running = false;
      row.inert = false;
      row.removeAttribute('aria-busy');
      locked.forEach(([control, disabled]) => { control.disabled = disabled; });
      locked = [];
      button.textContent = button.dataset.label;
      sync();
    };
    button.addEventListener('click', async () => {
      if (button.disabled || running) return;
      const checkout = document.querySelector('[data-ae-checkout] button[name="checkout"]');
      if (!checkout || typeof window.epicProductItem !== 'function') {
        message.textContent = button.dataset.error;
        return;
      }
      const item = window.epicProductItem(add);
      if (!Number.isSafeInteger(item.id) || item.id < 1) return;
      running = true;
      button.disabled = true;
      button.textContent = button.dataset.loading;
      message.textContent = button.dataset.loading;
      row.setAttribute('aria-busy', 'true');
      row.inert = true;
      locked = [...product.querySelectorAll('.product-variant-button, .product-makeup-shade, #productVariantSelector, .product-makeup-shadeSelector')]
        .map(control => [control, control.disabled]);
      locked.forEach(([control]) => { control.disabled = true; });
      try {
        await window.AE.cart.prepareCheckout(item);
        if (checkout.disabled || window.AE.cart.busy || Number(add.dataset.variantId) !== item.id) {
          throw new Error(button.dataset.error);
        }
        checkout.click();
        timer = setTimeout(() => {
          reset();
          message.textContent = button.dataset.error;
          button.focus({preventScroll:true});
        }, 20000);
      } catch (error) {
        reset();
        message.textContent = error.message || button.dataset.error;
        button.focus({preventScroll:true});
      }
    });
    new MutationObserver(sync).observe(add, {attributes:true, attributeFilter:['data-variant-id', 'disabled']});
    document.addEventListener('epic:cart:state', sync);
    window.addEventListener('pageshow', () => { reset(); message.textContent = ''; });
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["epic-card-labels"] && !Shopify.designMode) return;
  try {
    (() => {
  const cards = new WeakMap();
  const productValues = new WeakSet();
  const valueCache = new Map();
  const valueQueue = [];
  let valueTimer = 0;
  let activeBatches = 0;
  const componentFields = `id requiresComponents price { currencyCode }
    components(first:50, after:$after) {
      nodes { quantity productVariant { price { amount currencyCode } compareAtPrice { amount currencyCode } } }
      pageInfo { hasNextPage endCursor }
    }`;
  const batchQuery = `query EpicBundleValues($ids:[ID!]!, $country:CountryCode!, $after:String) @inContext(country:$country) {
    nodes(ids:$ids) { ... on ProductVariant { ${componentFields} } }
  }`;
  const requestValues = async (ids, country, after = null) => {
    const response = await fetch('/api/2026-07/graphql.json', {
      method:'POST', headers:{ 'Content-Type':'application/json' },
      body:JSON.stringify({ query:batchQuery, variables:{ ids, country, after } }),
      signal:AbortSignal.timeout(10000)
    });
    if (!response.ok) throw new Error('Bundle value unavailable');
    const payload = await response.json();
    if (payload.errors?.length || !Array.isArray(payload.data?.nodes)) throw new Error('Incomplete bundle value');
    return payload.data.nodes;
  };
  const totalValue = async (node, country, currency) => {
    if (!node?.requiresComponents || node.price?.currencyCode !== currency) return null;
    let connection = node.components;
    let total = 0;
    let count = 0;
    const cursors = new Set();
    while (connection) {
      for (const component of connection.nodes) {
        const item = component.productVariant;
        const quantity = component.quantity;
        const price = Number(item?.price?.amount);
        const compare = item?.compareAtPrice ? Number(item.compareAtPrice.amount) : 0;
        if (!Number.isInteger(quantity) || quantity <= 0 || !Number.isFinite(price) || price < 0 ||
            !Number.isFinite(compare) || compare < 0 || item.price.currencyCode !== currency ||
            (item.compareAtPrice && item.compareAtPrice.currencyCode !== currency)) return null;
        total += Math.round(Math.max(price, compare) * 100) * quantity;
        count += 1;
      }
      if (!connection.pageInfo.hasNextPage) return count > 0 && total > 0 ? total / 100 : null;
      const cursor = connection.pageInfo.endCursor;
      if (!cursor || cursors.has(cursor)) return null;
      cursors.add(cursor);
      const [next] = await requestValues([node.id], country, cursor);
      if (!next?.requiresComponents || next.price?.currencyCode !== currency) return null;
      connection = next.components;
    }
    return null;
  };
  const flushValues = () => {
    valueTimer = 0;
    while (activeBatches < 2 && valueQueue.length) {
      const first = valueQueue.shift();
      const batch = [first];
      for (let index = 0; index < valueQueue.length && batch.length < 8;) {
        const item = valueQueue[index];
        if (item.country === first.country && item.currency === first.currency) batch.push(...valueQueue.splice(index, 1));
        else index += 1;
      }
      activeBatches += 1;
      (async () => {
        try {
          const nodes = await requestValues(batch.map(item => item.id), first.country);
          const byId = new Map(nodes.filter(Boolean).map(node => [node.id, node]));
          await Promise.all(batch.map(async item => {
            try { item.resolve(await totalValue(byId.get(item.id), item.country, item.currency)); }
            catch { item.resolve(null); }
          }));
        } catch { batch.forEach(item => item.resolve(null)); }
        finally { activeBatches -= 1; flushValues(); }
      })();
    }
  };
  const bundleValue = (variantId, country, currency) => {
    if (!/^\d+$/.test(variantId || '') || !country || !currency) return Promise.resolve(null);
    const id = 'gid://shopify/ProductVariant/' + variantId;
    const key = [id, country, currency].join(':');
    if (!valueCache.has(key)) {
      valueCache.set(key, new Promise(resolve => valueQueue.push({ id, country, currency, resolve })));
      if (!valueTimer) valueTimer = setTimeout(flushValues, 0);
    }
    return valueCache.get(key);
  };
  const formatValue = (total, data) => {
    if (!(total > 0)) return '';
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
      style:'currency', currency:data.currency, currencyDisplay:'narrowSymbol', minimumFractionDigits:0, maximumFractionDigits:2
    }).format(total);
    return data.valueTemplate.replace('__AMOUNT__', money);
  };
  const pending = new Set();
  let frame = 0;
  const moneyAttribute = 'data-limoniapps-discountninja-price-cents-basecurrency';
  const shippingCandidate = (key) => {
    let hash = 2166136261;
    for (let i = 0; i < key.length; i += 1) hash = Math.imul(hash ^ key.charCodeAt(i), 16777619);
    return (hash >>> 0) % 10 === 0;
  };
  const amount = (root, selector) => {
    const node = root.querySelector(selector + ' [' + moneyAttribute + ']');
    if (!node) return null;
    const number = Number(node.getAttribute(moneyAttribute));
    return Number.isFinite(number) && number >= 0 ? number : null;
  };
  const readPrices = (state) => {
    let price = Number(state.labels.dataset.cardPrice);
    let compare = Number(state.labels.dataset.cardCompare);
    const replacement = state.price.querySelector('[data-la-dn-replaced-root]');
    if (replacement && getComputedStyle(replacement).display !== 'none') {
      const discounted = amount(replacement, '.limoniapps-discountninja-shortcode-discounted_price');
      const original = amount(replacement, '.limoniapps-discountninja-shortcode-original_price');
      if (discounted !== null) price = discounted;
      if (original !== null) compare = original;
    }
    return { price, compare };
  };
  const update = (state) => {
    const { price, compare } = readPrices(state);
    if (!Number.isFinite(price) || price < 0) return;
    const saving = Number(state.labels.dataset.savingPercentage) || 0;
    const value = state.labels.dataset.valueLabel === 'true';
    const badgeText = state.labels.dataset.badgeText || '';
    let text = '';
    const valueText = state.bundleText || (value ? badgeText : '');
    if (valueText) text = valueText;
    else if (saving > 0) text = state.labels.dataset.savingTemplate.replace('__PERCENT__', String(saving));
    else if (badgeText && !value) text = badgeText;
    else if (price > 6000 && state.shipping) text = state.labels.dataset.shippingLabel;
    if (state.rectangle.textContent !== text) state.rectangle.textContent = text;
    state.rectangle.hidden = !text;
    state.rectangle.classList.toggle('epic-card-rectangle--sale', !valueText && saving > 0);
    state.rectangle.classList.toggle('epic-card-rectangle--value', !!valueText);
    if (text) state.rectangle.title = text;
    else state.rectangle.removeAttribute('title');
    if (state.valueLabel) {
      state.valueLabel.hidden = true;
      state.valueLabel.textContent = valueText;
    }
  };
  const schedule = (card) => {
    pending.add(card);
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      for (const item of pending) {
        if (item.isConnected) update(cards.get(item));
      }
      pending.clear();
    });
  };
  const connect = (card) => {
    if (cards.has(card)) return;
    const labels = card.querySelector('[data-epic-card-labels]');
    const price = card.querySelector('.limoniapps-discountninja-productprice, [data-la-dn-price]');
    const rectangle = labels?.querySelector('[data-epic-rectangle]');
    if (!labels || !price || !rectangle) return;
    const state = { labels, price, rectangle, valueLabel:card.querySelector('[data-epic-value-label]'), shipping:shippingCandidate(labels.dataset.productKey || '') };
    cards.set(card, state);
    update(state);
    bundleValue(labels.dataset.variantId, labels.dataset.country, labels.dataset.currency).then(total => {
      state.bundleText = formatValue(total, labels.dataset);
      if (card.isConnected) update(state);
    });
    const observer = new MutationObserver(() => schedule(card));
    observer.observe(price, { subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:[moneyAttribute, 'class', 'style'] });
  };
  const connectProductValue = (label) => {
    if (productValues.has(label)) return;
    productValues.add(label);
    const page = label.closest('.epic-product-page');
    const button = page?.querySelector('#productTemplate-addToBagButton');
    let revision = 0;
    const textNodes = [];
    page?.querySelectorAll('.epic-product-summary, .epic-product-prose').forEach(root => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (/valued? at\s*\$\d+(?:,\d{3})*(?:\.\d{1,2})?/i.test(node.nodeValue)) textNodes.push({ node, original:node.nodeValue });
      }
    });
    const refresh = async () => {
      const current = ++revision;
      label.textContent = label.dataset.fallbackValue || '';
      label.hidden = !label.textContent;
      textNodes.forEach(item => { item.node.nodeValue = item.original; });
      const id = button?.dataset.variantId || label.dataset.variantId;
      const total = await bundleValue(id, label.dataset.country, label.dataset.currency);
      if (current !== revision || !label.isConnected) return;
      const text = formatValue(total, label.dataset);
      if (!text) return;
      label.textContent = text;
      label.hidden = false;
      textNodes.forEach(item => {
        item.node.nodeValue = item.original.replace(/valued? at\s*\$\d+(?:,\d{3})*(?:\.\d{1,2})?/gi, () => text);
      });
    };
    refresh();
    if (button) new MutationObserver(refresh).observe(button, { attributes:true, attributeFilter:['data-variant-id'] });
  };
  const scan = (root) => {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.('.epic-badged-card')) connect(root);
    root.querySelectorAll('.epic-badged-card').forEach(connect);
    if (root.matches?.('[data-epic-product-value]')) connectProductValue(root);
    root.querySelectorAll('[data-epic-product-value]').forEach(connectProductValue);
  };
  const start = () => {
    scan(document);
    new MutationObserver((records) => {
      for (const record of records) for (const node of record.addedNodes) scan(node);
    }).observe(document.body, { childList:true, subtree:true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
